import React from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import RightArrow from "../../images/Svg/whiteRightArrow.svg";

const GoBack = ({ home }) => {
  const navigation = useNavigate();

  let location = useLocation();
  let pn = location?.pathname;
  const { deso, twitter } = useSelector((state) => state.auth);

  const handleGoBack = () => {
    // go back
    if (home) {
      window.location.href = "/";
    } else {
      navigation(-1);
    }
  };

  return (
    <div className="hidden lg:flex items-center justify-between w-[106px]  h-[40px] hover:bg-[#F6F7FF] rounded-[4px]">
      <div onClick={handleGoBack} className="flex items-center cursor-pointer">
        <img className="mx-[8px]" src={RightArrow} alt="" />
        <p className="text-[#161616] text-[16px]">Go Back {home && "home"}</p>
      </div>
    </div>
  );
};

export default GoBack;
